import { useTranslation } from 'react-i18next'
import Modal from '../common/Modal/Modal'
import { DriverFilter } from '../../types/enums'
import { useState } from 'react'
interface DriverModalProps {
  visible: boolean
  filterChanged: (items: DriverFilter) => void
  onClose: () => void
  selectedDriver?: DriverFilter
}
export function DriverSelectionModal(props: DriverModalProps) {
  const { visible, onClose, filterChanged, selectedDriver } = props

  const [onlyDriverToShow, setOnlyDriverToShow] = useState(selectedDriver?.drivers ?? false)
  const [onlyPoolCarToShow, setOnlyPoolCarToShow] = useState(selectedDriver?.pool_cars ?? false)
  const [onlyNotAssignedToShow, setOnlyNotAssignedToShow] = useState(selectedDriver?.not_assigned ?? false)
  const [searchString, setSearchString] = useState(selectedDriver?.searchString ?? '')

  const { t } = useTranslation('common')

  function applyDriverFilters() {
    const newDriverFilter: DriverFilter = {
      searchString: searchString.trim(),
      drivers: onlyDriverToShow,
      pool_cars: onlyPoolCarToShow,
      not_assigned: onlyNotAssignedToShow,
    }
    filterChanged(newDriverFilter)
    onClose()
  }
  return (
    <Modal title={t('VEHICLE_ASSIGNMENT_FILTER')} onClose={onClose} visible={visible}>
      <div className="grid-cols-cc">
        <div className="driverModalParent">
          <div>
            <input
              onChange={() => setOnlyPoolCarToShow(!onlyPoolCarToShow)}
              checked={onlyPoolCarToShow}
              type="checkBox"
            />
            <label>{t('POOL_CARS')}</label>
          </div>
          <div>
            <input onChange={() => setOnlyDriverToShow(!onlyDriverToShow)} checked={onlyDriverToShow} type="checkBox" />
            <label>{t('DRIVERS')}</label>
          </div>
          <div>
            <input
              onChange={() => setOnlyNotAssignedToShow(!onlyNotAssignedToShow)}
              checked={onlyNotAssignedToShow}
              type="checkBox"
            />
            <label>{t('NOT_ASSIGNED')}</label>
          </div>
          <div className="driverModalInput">
            <div className="input-area">
              <input
                name={`fieldnameveryunique${new Date().getTime()}`}
                autoComplete="none"
                list="autocompleteOff"
                placeholder={t('SEARCH_DRIVER_NAME_LOCATION')}
                value={searchString}
                onInput={(e) => setSearchString(e.currentTarget.value)}
                type="text"
                className="transparent"
              />
            </div>
            <button onClick={() => applyDriverFilters()} style={{ margin: '0px' }}>
              {t('APPLY')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
